import React from "react";
import styles from "./PoiInfoPanel.module.css";

export default function PoiInfoPanel({ point, onClose, backLabel }) {
  if (!point) return null;

  return (
    <div className={styles.panel}>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Schließen"
      >
        ×
      </button>

      {point.imageUrl && (
        <img
          src={point.imageUrl}
          alt={point.name}
          className={styles.image}
        />
      )}

      <div className={styles.body}>
        {/* back to the module's result list, when there is one */}
        {backLabel && (
          <button type="button" className={styles.backButton} onClick={onClose}>
            {backLabel}
          </button>
        )}
        <h3 className={styles.title}>{point.name}</h3>
        {/* date/time line — only events have this */}
        {point.when && <p className={styles.when}>{point.when}</p>}
        {point.description && (
          <p className={styles.description}>{point.description}</p>
        )}

        {/* contact details — only listings (Gastronomie, Ferienhäuser) have these */}
        {(point.address || point.phone || point.email || point.url) && (
          <ul className={styles.details}>
            {point.address && <li>{point.address}</li>}
            {point.phone && (
              <li>
                <a href={`tel:${point.phone.replace(/\s+/g, "")}`}>{point.phone}</a>
              </li>
            )}
            {point.email && (
              <li>
                <a href={`mailto:${point.email}`}>{point.email}</a>
              </li>
            )}
            {point.url && (
              <li>
                <a href={point.url} target="_blank" rel="noopener noreferrer">
                  Website
                </a>
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}
